'use client';

import React from 'react';
import { Box, VStack, Text, Flex } from '@skin-seoul/design-system';
import { AwardLeftIcon } from '@/assets/AwardLeftIcon';
import { AwardRightIcon } from '@/assets/AwardRightIcon';
import SectionContainer from '../../components/SectionContainer';
import { useParams } from 'next/navigation';
import { useProductService, useRegionCurrency } from '@skin-seoul/service';
import { unescape } from 'es-toolkit/string';
import Image from 'next/image';
import AwardLeftBg from './assets/graphic_left.png';
import AwardRightBg from './assets/graphic_right.png';
const SkinSightAwardSection = () => {
  const {
    useGetProductsDetail
  } = useProductService();
  const {
    currency
  } = useRegionCurrency();
  const params = useParams();
  const {
    data: {
      awardsAndHonor
    }
  } = useGetProductsDetail({
    slug: params.slug as string,
    currency
  });
  const {
    awards,
    honors
  } = awardsAndHonor;
  const awardsWithType = awards.map(award => ({
    ...award,
    type: 'award'
  }));
  const honorsWithType = honors.map(honor => ({
    ...honor,
    type: 'honor'
  }));
  const allAwards = [...awardsWithType, ...honorsWithType];
  if (!allAwards || allAwards.length === 0) {
    return null;
  }
  return <SectionContainer headerTitle="SkinSight™ Award" data-sentry-element="SectionContainer" data-sentry-component="SkinSightAwardSection" data-sentry-source-file="SkinSightAwardSection.tsx">
      <VStack gap={3} width="100%" alignItems="flex-start" data-sentry-element="VStack" data-sentry-source-file="SkinSightAwardSection.tsx">
        {allAwards.map((award, index) => <Box key={index} width="100%" height={{
        base: '124px',
        tablet: '136px'
      }} backgroundColor="black" borderRadius={12} position="relative" overflow="hidden">
            {/* Background SVG */}
            <Box position="absolute" top={0} left={index % 2 === 0 ? 0 : 'auto'} right={index % 2 === 0 ? 'auto' : 0} height="100%" zIndex={0}>
              {index % 2 === 0 ? <Image src={AwardLeftBg} height={124} alt="Award Left Background" style={{
            objectFit: 'cover',
            width: '100%',
            height: '100%'
          }} /> : <Image src={AwardRightBg} height={124} alt="Award Right Background" style={{
            objectFit: 'cover',
            width: '100%',
            height: '100%'
          }} />}
            </Box>
            {/* Content Container */}
            <Flex direction="row" alignItems="center" justifyContent="center" height="100%" position="relative" zIndex={1} paddingY={{
          base: 4,
          tablet: 5
        }}>
              <Box mx={4}>
                <AwardLeftIcon />
              </Box>

              {/* Center Content */}
              <Flex as="div" display="inline-flex" // inline-flex로 변경
          direction="column" alignItems="center" justifyContent="center" gap={2}>
                {/* Category */}
                <Text textStyle={{
              base: 'label.xsmall',
              tablet: 'label.small'
            }} color="primary.50" fontWeight="normal" textAlign="center">
                  Best Skincare Product 2025
                </Text>

                {/* Title */}
                <Text textStyle={{
              base: 'heading.h5',
              tablet: 'heading.h4'
            }} color="white" fontWeight="semibold" letterSpacing={{
              tablet: '-0.56px'
            }} textAlign="center">
                  {unescape(award.name)}
                </Text>

                {/* Description */}
                <Text textStyle={{
              base: 'label.xsmall',
              tablet: 'label.small'
            }} color="neutral.100" fontWeight="normal" textAlign="center">
                  {award?.description || 'Provides 3 or more benefits'}
                </Text>
              </Flex>

              <Box mx={4}>
                <AwardRightIcon />
              </Box>
            </Flex>
          </Box>)}
      </VStack>
    </SectionContainer>;
};
export default SkinSightAwardSection;